import { render, staticRenderFns } from "./ByClient.vue?vue&type=template&id=a89debf8"
import script from "./ByClient.vue?vue&type=script&lang=js"
export * from "./ByClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports